import config from "@/config";

const {ENV} = config;

export const logData = (level, title, data) => {
	const isDebugMode = new URLSearchParams(location.search).get("debug") === "true";
	const logLevels = { 
		debug: console.debug,
		info: console.info,
		warn: console.warn,
		error: console.error,
		log: console.log
	}
	const logFunction = logLevels[level] || logLevels.log;
		if (ENV === "production" && !isDebugMode) {
			return
		}
		logFunction(title, data);
}